import {Component, inject} from '@angular/core'
import {MatIcon} from '@angular/material/icon'
import {Loader} from '../../services/loader'
import {MatTooltip} from '@angular/material/tooltip'

@Component({
  selector: 'spb-progress',
  imports: [
    MatIcon,
    MatTooltip
  ],
  templateUrl: './progress.html',
  styleUrl: './progress.scss'
})
export class Progress {

  protected readonly loader = inject(Loader)

}
